import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { BadgeCheck, Gavel, Store, ArrowRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import { SAR } from "../souq";
import { Countdown, LivePrice, VerifiedTraderBadge } from "./SouqLive";
import Reveal from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomeSouq() {
  const { t, lang } = useApp();
  const [items, setItems] = useState(null);
  useEffect(() => {
    axios.get(`${API}/souq/listings`, { params: { sort: "ending" } }).then((r) => setItems((r.data.items || []).slice(0, 4))).catch(() => setItems([]));
  }, []);
  if (items && !items.length) return null;
  return (
    <section className="home-souq" id="live-souq" data-testid="home-souq">
      <div className="home-souq-grid">
        {(items || [0, 1, 2, 3]).map((l, k) => items ? (
          <Reveal key={l.listing_id} delay={k * 90}>
            <Link to={`/souq/listing/${l.listing_id}`} className="home-souq-card glass-card" data-testid={`home-souq-${l.listing_id}`}>
              <div className="souq-card-top">
                <span className="souq-variety">{lang === "ar" ? l.variety_ar : l.variety_en}</span>
                {l.verified && <span className="souq-badge"><BadgeCheck size={12} /> {t("souq.verified")}</span>}
                {l.seller_type === "trader" && l.seller_verified && <VerifiedTraderBadge />}
              </div>
              <p className="souq-farm">{l.farm_name} · {lang === "ar" ? l.region_ar : l.region_en} · {l.quantity_kg} kg</p>
              <div className="souq-price-row">
                <div><small>{l.bid_count > 0 ? t("souq.currentBid") : t("souq.startingPrice")}</small><LivePrice value={l.current_price} lang={lang} className="souq-price" /></div>
                {l.buy_now_price && <span className="souq-buynow-chip">{t("souq.buyNow")} {SAR(l.buy_now_price, lang)}</span>}
              </div>
              <div className="souq-card-foot">
                <Countdown endsAt={l.ends_at} />
                <span className="souq-bids"><Gavel size={12} /> {l.bid_count === 1 ? t("souq.bid1") : `${l.bid_count} ${t("souq.bids")}`}</span>
              </div>
            </Link>
          </Reveal>
        ) : <div key={k} className="home-souq-card glass-card skel-card" />)}
      </div>
      <div className="home-cta-row">
        <Link to="/souq" className="btn-lux-gold" data-testid="home-souq-cta"><Store size={16} /> {t("home.souq.cta")} <ArrowRight size={15} className="rtl-flip" /></Link>
        <Link to="/auth?type=buyer&mode=register&next=/souq" className="btn-lux-ghost" data-testid="home-souq-join">{t("souq.signupBuyer")}</Link>
      </div>
    </section>
  );
}
